var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasteCollectionJar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 90,
    fill: "none",
    viewBox: "0 -3 55 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3ECEF",
    fillRule: "evenodd",
    d: "M52 14H3l-3 4v70h55V18l-3-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6F7",
    d: "M3 18h25v70H5a2 2 0 0 1-2-2V18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9DADF",
    d: "M47 18h6v68a2 2 0 0 1-2 2h-4V18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C9CE",
    d: "M0 79h55v9H0v-9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1B4BA",
    d: "M0 87h55v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zM2 79h2v6a1 1 0 1 1-2 0v-6zM6 79h2v6a1 1 0 1 1-2 0v-6zM10 79h2v6a1 1 0 1 1-2 0v-6zM14 79h2v6a1 1 0 1 1-2 0v-6zM18 79h2v6a1 1 0 1 1-2 0v-6zM22 79h2v6a1 1 0 1 1-2 0v-6zM26 79h3v5.5a1.5 1.5 0 0 1-3 0V79zM31 79h2v6a1 1 0 1 1-2 0v-6zM35 79h2v6a1 1 0 1 1-2 0v-6zM39 79h2v6a1 1 0 1 1-2 0v-6zM43 79h2v6a1 1 0 1 1-2 0v-6zM47 79h2v6a1 1 0 1 1-2 0v-6zM51 79h2v6a1 1 0 1 1-2 0v-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6F7",
    d: "M6 14h23l-1 4H3l3-4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9DADF",
    d: "M50.5 14H45l2 4h6l-2.5-4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 29,
    y: 12,
    fill: "#C9DADF",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 2,
    x: 2,
    y: 12,
    fill: "#F2F6F7",
    rx: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3ECEF",
    d: "M2 11h51v2H2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6F7",
    d: "M2 11a1 1 0 0 1 1-1h49a1 1 0 0 1 1 1v1H2v-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7E5E9",
    d: "M55 9.648v1.822c0 .28-.328.51-.74.528-.018.002-.034.002-.053.002H.79c-.019 0-.035 0-.053-.002C.326 11.98 0 11.75 0 11.471V9.647c0-.292.355-.53.79-.53h.216V1.216c0-.243.262-.447.606-.49V.5C1.612.225 1.95 0 2.36 0h50.28a.982.982 0 0 1 .56.17l.017.012c.107.086.17.197.17.317v.227c.342.045.607.249.607.49v7.902h.216c.435-.002.79.236.79.53z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6F7",
    d: "M20.477 11.469V9.648c0-.292.352-.53.784-.53h.215V1.216c0-.243.26-.447.601-.49V.5c0-.274.334-.499.742-.499H2.342C1.934 0 1.6.224 1.6.5v.226C1.261.771 1 .975 1 1.216v7.902H.784c-.432 0-.784.238-.784.53v1.822c0 .28.323.51.731.528C.75 12 .766 12 .784 12h20.477c-.018 0-.034 0-.053-.002-.408-.02-.73-.25-.73-.53z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BECFD3",
    d: "M4.21.893H2.933v8.076h1.279V.893zM6.87.893H5.59v8.076h1.28V.893zM9.53.893H8.25v8.076h1.28V.893zM12.187.893h-1.279v8.076h1.279V.893zM14.845.893h-1.278v8.076h1.278V.893zM17.507.893h-1.281v8.076h1.28V.893zM20.163.893h-1.279v8.076h1.279V.893z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3BAC1",
    d: "M22.821.893h-1.278v8.076h1.278V.893zM25.48.893h-1.279v8.076h1.279V.893zM28.139.893H26.86v8.076h1.279V.893zM30.8.893h-1.279v8.076H30.8V.893zM33.461.893h-1.28v8.076h1.28V.893zM36.117.893H34.84v8.076h1.278V.893zM38.779.893h-1.282v8.076h1.282V.893zM41.437.893h-1.281v8.076h1.281V.893zM44.096.893h-1.282v8.076h1.282V.893zM46.755.893h-1.282v8.076h1.282V.893zM49.41.893h-1.278v8.076h1.279V.893zM52.069.893H50.79v8.076h1.279V.893z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteCollectionJar);
export default __webpack_public_path__ + "static/media/waste_collection_jar.e9207dee8877d92685ff9e86fe4fa17a.svg";
export { ForwardRef as ReactComponent };